import { OTPRequest } from "../otp/dto";
import { LoginRequestDTO } from "./dto";
import { LoginServiceImpl } from "./serviceImpl";


export interface LoginService {
    login(request: LoginRequestDTO): Promise<string>
    OTP(request: OTPRequest, token: string): Promise<void>
    verifyToken(token: string): Promise<void>
}

export function NewLoginService(): LoginService {
    return new LoginServiceImpl();
}
